import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NotificationModel } from '../../models/notification.model';
import { PageableResponse, SocietiesService, Society } from '@pwc-bei/common';
import { Observable } from 'rxjs';
import { BasePage } from '../../../../pages/base-page/base-page';
import { NotificationListService } from '../../services/notification-list.service';
import { debounceTime, switchMap } from 'rxjs';
import { NotificationData } from '../../models/notification-data.model';

@Component({
    selector: 'app-notifications-panel',
    templateUrl: './notifications-panel.component.html',
    styleUrls: ['./notifications-panel.component.scss'],
    standalone: false
})
export class NotificationsPanelComponent
  extends BasePage
  implements OnInit, AfterViewInit {
  @Input() notificationInfo: NotificationData = { notificationCount: 0 };
  @Output() onClosePanel: EventEmitter<boolean> = new EventEmitter<boolean>();

  dataSet: NotificationModel[] = [];
  initialized = false;
  declare pagination: PageableResponse<any>;

  selectedElementId: any;
  total$: Observable<number>;

  constructor(
    private notificationListService: NotificationListService,
    private changeDetector: ChangeDetectorRef,
    private societiesService: SocietiesService,
  ) {
    super();
  }

  ngOnInit(): void {
    // console.log('Init notification');
    this.pageSize = 3;
    this.sortType = 'date';
    this.sortDirection = 'desc';
    super.ngOnInit();

    this.subscriptions.push(
      this.notificationListService.pagination$.subscribe((pagination) => {
        this.pagination = { ...pagination };
      }),
    );

    this.initSearch();
    this.onSearch();
  }

  initSearch(): void {
    this.subscriptions.push(
      this.searchTrigger$
        .pipe(
          debounceTime(200),
          switchMap(() => this.societiesService.getSelectedSociety()),
          switchMap((society: Society) => {
            const search: Partial<any> = {
              society: society.id,
            };

            if (this.sortDirection !== '' && this.sortType != null) {
              search.sort = `${this.sortType},${this.sortDirection}`;
            }

            search.page = this.currentPage;
            search.size = this.pageSize;

            return this.notificationListService.search(search);
          }),
        )
        .subscribe((data: NotificationModel[]) => {
          this.initialized = true;
          this.dataSet = [...data];
          // console.log('notification', this.dataSet);
        }),
    );
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.onSearch();
  }

  ngAfterViewInit(): void {
    this.initialized = true;
    this.changeDetector.detectChanges();
  }

  closePanel() {
    this.onClosePanel.emit(true);
  }

  readNotification(obj: NotificationModel) {
    const oldNewNotification = this.notificationInfo.notificationCount;
    this.notificationListService.markAsRead(obj.id).subscribe(
      {
        next: (res) => {
          // this.notificationsListService.loadService();
          this.dataSet.filter((n) => (n.isRead = n.isRead || n.id === obj.id));
          if (this.notificationInfo.notificationCount === oldNewNotification) {
            this.notificationInfo.notificationCount--;
          }
        },
        error: (err) => {
          // console.log(err);
        },
      }
    );
  }

  hasUnreadItems() {
    return this.dataSet.filter((n) => n.isRead).length > 0;
  }

  unreadItems(): any[] {
    return this.dataSet ? this.dataSet.filter((n) => n.isRead) : [];
  }
}
